import {MAIL_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function sendMessageViaSms(data) {
    return axiosInstance
        .post(`${MAIL_ENDPOINT}/sms/sendSMS`, data, {})
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function sendMessageViaEmail(data) {
    return axiosInstance
        .post(`${MAIL_ENDPOINT}/mail/sendMail`, data, {})
        .then(res => res.data)
        .catch(error => console.log(error))
}
